import { IAttribute, IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from '../linkedservice/linkedservice';
import { format } from '../../shared/utils/string.util';
import { IPrivateEndpointCompatible } from '../../interfaces/IPrivateEndpointCompatible';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { Credential } from '../credential/credential';
import { AuthenticationType } from '../../interfaces/IAuthenticationType';
import { GlobalVariables } from '../../constants/globals';

export const azureKeyVaultAuthTypes = {
    MSIAuthentication: 'MSIAuthentication',
    UserAssignedManagedIdentity: 'UserAssignedManagedIdentity',
    UserAuth: AuthenticationType.UserAuth
};

export const azureKeyVaultAuthRefTypes = {
    CredentialRefTypeAuthentication: 'credential',
    InlineRefTypeAuthentication: 'inline'
};

@Metamodel.model({
    name: 'AzureKeyVault',
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.AzureKeyVault_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.AzureKeyVault_DisplayText)
    ]
})
export class AzureKeyVaultLinkedService extends LinkedService implements IPrivateEndpointCompatible {

    public static readonly MODEL: IModel;
    public static readonly BASE_URL: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_BaseUrl,
        templatable: true,
        association: 'BASE_URL'
    })
    public baseUrl?: string;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: (linkedservice: AzureKeyVaultLinkedService, referencedCredential: Credential): IViolation[] | undefined => {
                // run cred validator for MSI if credential field is populated or for UAMI which must have a cred reference
                if (linkedservice &&
                    ((linkedservice.authenticationMethod === azureKeyVaultAuthTypes.MSIAuthentication && linkedservice.authRefMethod === azureKeyVaultAuthRefTypes.CredentialRefTypeAuthentication) ||
                    linkedservice.authenticationMethod === azureKeyVaultAuthTypes.UserAssignedManagedIdentity ||
                    (GlobalVariables.enableConnectorUserAuthCred && linkedservice.authenticationMethod === azureKeyVaultAuthTypes.UserAuth)) &&
                    !referencedCredential) {
                    return [{ message: () => shellStringResources.Error_InvalidCredentialReferenced }];
                }
                return undefined;
            }
        }
    })
    public credential?: Credential;

    public authRefMethod?: string = azureKeyVaultAuthRefTypes.InlineRefTypeAuthentication;

    public authenticationMethod?: string = azureKeyVaultAuthTypes.MSIAuthentication;

    private _akvResourceID: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        let resourceName = '';
        if (this.baseUrl && this.baseUrl.startsWith('https://')) {
            resourceName = this.baseUrl.substr(8).split('.')[0];
        }
        if (!resourceName || this._akvResourceID && !this._akvResourceID.endsWith('/' + resourceName)) {
            this._akvResourceID = undefined;
        }
        return {
            id: this._akvResourceID,
            name: resourceName
        };
    }

    public setPEResourceID(value: string): void {
        this._akvResourceID = value;
    }
}
